<datalist id="emails">
  <option *ngIf="bulk_invite" value="{Contact_bulk.Email}">{{ '{Contact_bulk.Email}' }}</option>
  <ng-container *ngFor="let email of record_emails">
    <option (value)="(email.Email)">{{ email.Email }}</option>
  </ng-container>
</datalist>

<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div *ngIf="loading.isShow == false">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>
  <div *ngIf="using_normal_invite">
    <section
      role="dialog"
      tabindex="-1"
      class="slds-modal_large"
      aria-labelledby="id-of-modalheader-h2"
      aria-describedby="modal-content-id-1"
    >
      <div>
        <header class="slds-modal__header">
          <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Send Document For Signing</h2>
        </header>

        <div class="scrolling">
          <div class="slds-modal__content slds-grid slds-grow" id="modal-content-id-1">
            <div class="slds-grid slds-grid_vertical grid-settings">
              <div class="slds-p-vertical_x-small slds-p-horizontal_large slds-shrink-none slds-theme_shade">
                <div class="slds-form-element">
                  <ng-container *ngIf="bulk_invite">
                    <div class="alert alert-info" role="alert">
                      <p>
                        <strong><u>Role Settings:</u></strong> <br />
                        Please use <strong>{{ '{' }}{{ bulk_invite_type }}_bulk.{{ email_field }}}</strong> to
                        set the role for the bulk invite. <br />
                        Otherwise enter an email into the role using normal email format<strong
                          >###@###</strong
                        ><br />

                        <strong><u>Subject & Body Settings:</u></strong
                        ><br />
                        Please use <strong>{{ '{' }}{{ bulk_invite_type }}_bulk.RECORD_FIELD_NAME}</strong> to
                        pull the contact's information into <br />
                        the subject and body for the bulk invite.
                      </p>
                    </div>
                  </ng-container>

                  <strong
                    ><a
                      target="_blank"
                      href="{{ APP_BASE_LINK }}/webapp/document/{{
                        document_id
                      }}?viewonly=true&access_token={{ snToken }}"
                      >{{ document_name }}</a
                    ></strong
                  >
                  <!--unnecessary temp input - just for fix unwonted Chrome autofill password input-->
                  <input class="ps-hidden" type="text" list="emails" id="email" /><input
                    class="ps-hidden"
                    type="password"
                  />

                  <div class="email-role-block" *ngFor="let role of roles">
                    <div class="slds-form-element">
                      <label class="slds-form-element__label" for="email_role_{{ role.index }}"
                        >( {{ role.order }} ) {{ role.name }}</label
                      >

                      <ng-container *ngIf="bulk_invite">
                        <input
                          autocomplete="off"
                          type="text"
                          list="emails"
                          [(ngModel)]="role.email"
                          class="sn-sf-input"
                          id="email_role_{{ role.index }}"
                          placeholder="{{ '{' }}{{ bulk_invite_type }}_bulk.{{ email_field }}} or ###@##"
                          [readonly]="role.readonly"
                        />
                      </ng-container>
                      <ng-container *ngIf="!bulk_invite">
                        <input
                          autocomplete="off"
                          type="text"
                          list="emails"
                          [(ngModel)]="role.email"
                          class="sn-sf-input"
                          id="email_role_{{ role.index }}"
                          placeholder="###@##"
                          [readonly]="role.readonly"
                        />
                      </ng-container>

                      <button
                        *ngIf="!template_setting?.is_hide_advanced_settings"
                        (click)="role.isShowAdvanced = !role.isShowAdvanced"
                        class="btn btn-primary btn-advanced"
                      >
                        <span class="glyphicon glyphicon-chevron-down"></span>&nbsp;Advanced settings
                      </button>
                    </div>
                    <div
                      *ngIf="!template_setting?.is_hide_advanced_settings"
                      id="advance_settings_{{ role.index }}"
                      class="collapse"
                      [class.show]="role.isShowAdvanced"
                    >
                      <div class="panel panel-default">
                        <div class="panel-body">
                          <fieldset>
                            <div class="form-group">
                              <label class="slds-form-element__label" for="expiration_{{ role.index }}"
                                >Expiration Days</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="expiration_{{ role.index }}"
                                  name="expiration_{{ role.index }}"
                                  type="number"
                                  [(ngModel)]="role.expiration"
                                  class="sn-sf-input input-md"
                                  value="30"
                                />
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="slds-form-element__label" for="reminder_{{ role.index }}"
                                >Reminder</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="reminder_{{ role.index }}"
                                  name="reminder_{{ role.index }}"
                                  type="number"
                                  [(ngModel)]="role.reminder"
                                  class="sn-sf-input input-md"
                                  value="0"
                                  [disabled]="role.isReminderDisabled"
                                />
                              </div>
                            </div>

                            <div class="form-group">
                              <label class="slds-form-element__label" for="password_{{ role.index }}"
                                >Password</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="password_{{ role.index }}"
                                  name="password_{{ role.index }}"
                                  type="password"
                                  [(ngModel)]="role.password"
                                  placeholder="***********"
                                  class="sn-sf-input input-md"
                                />
                              </div>
                            </div>

                            <div class="form-group">
                              <label class="slds-form-element__label">
                                <input
                                  type="checkbox"
                                  name="allow-forwarding"
                                  [(ngModel)]="role.reassign"
                                  class="slds-checkbox"
                                />
                                <span>Allow Forwarding</span>
                              </label>
                            </div>

                            <div class="form-group">
                              <div>
                                <button
                                  id="submit_{{ role.index }}"
                                  class="btn btn-success no-margin"
                                  name="submit_{{ role.index }}"
                                  (click)="role.isShowAdvanced = !role.isShowAdvanced"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="slds-grow">
                <div class="slds-form slds-form_horizontal">
                  <div class="slds-form-element">
                    <label class="slds-form-element__label tar" for="CCInput">
                      cc
                      <span class="glyphicon glyphicon-question-sign sn-tooltip sup">
                        <span class="sn-tooltip__text w-180"
                          >Carbon copy recipients will receive an email with a copy of a signed
                          document.</span
                        >
                      </span>
                    </label>

                    <div class="slds-form-element__control">
                      <input
                        autocomplete="off"
                        type="text"
                        id="CCInput"
                        class="sn-sf-input"
                        (keyup.space)="addToCC(CCInput)"
                        #CCInput
                        placeholder="###@## ###@## ###@##"
                      />
                      <br />
                      <ng-container *ngFor="let email of cc">
                        <span class="label label-info"
                          >{{ email }}
                          <a (click)="removeFromCC(email)">x</a>
                        </span>
                      </ng-container>
                    </div>
                  </div>
                  <div class="slds-form-element">
                    <label class="slds-form-element__label" for="subject">Subject</label>
                    <div class="slds-form-element__control">
                      <input
                        autocomplete="off"
                        type="text"
                        id="subject"
                        [(ngModel)]="subject"
                        class="sn-sf-input"
                        placeholder="Invite Email Subject"
                      />
                    </div>
                  </div>
                  <div class="slds-form-element">
                    <label class="slds-form-element__label" for="body">Body</label>
                    <div class="slds-form-element__control">
                      <textarea
                        [(ngModel)]="body"
                        id="body"
                        class="slds-textarea"
                        placeholder="Invite Email Body"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="slds-modal__footer left">
          <!--<button class="btn btn-neutral">Cancel</button>-->
          <ng-container *ngIf="bulk_invite">
            <button class="btn btn-primary" (click)="send_bulk_invite(CCInput)">Send Bulk Invite</button>
          </ng-container>
          <ng-container *ngIf="!bulk_invite">
            <button class="btn btn-primary" (click)="send_invite(CCInput)">Send</button>
          </ng-container>
        </footer>
      </div>
    </section>
  </div>

  <div *ngIf="using_document_group">
    <section
      role="dialog"
      tabindex="-1"
      class="slds-modal_large"
      aria-labelledby="id-of-modalheader-gr-h2"
      aria-describedby="modal-content-gr-id-1"
    >
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <h2 id="id-of-modalheader-gr-h2" class="slds-text-heading_medium">
            Send Document Group For Signing
          </h2>
        </header>
        <div class="slds-modal__content slds-grid slds-grow" id="modal-content-gr-id-1">
          <div class="slds-grid slds-grid_vertical grid-settings">
            <div class="slds-p-vertical_x-small slds-p-horizontal_large slds-shrink-none slds-theme_shade">
              <div class="slds-form-element">
                <ng-container *ngFor="let document_role of document_roles; let i = index">
                  <br />
                  <strong
                    ><a
                      target="_blank"
                      href="{{ APP_BASE_LINK }}/webapp/document/{{
                        document_role.document_id
                      }}?viewonly=true&access_token={{ snToken }}"
                      >{{ document_role.document_name }}</a
                    ></strong
                  >
                  <!--unnecessary temp input - just for fix unwonted Chrome autofill password input-->
                  <input class="ps-hidden" type="text" list="emails" id="email" /><input
                    class="ps-hidden"
                    type="password"
                  />

                  <div class="email-role-block" *ngFor="let role of document_role.roles">
                    <div class="slds-form-element">
                      <table class="full-width">
                        <tr>
                          <td class="left-td">
                            <div class="select-style">
                              <select
                                id="selectedOrder"
                                class="slds-select"
                                #selectedOrder
                                (change)="updateDocumentGroupRolesOrder(selectedOrder, role)"
                                [disabled]="role.isOrderReadonly"
                              >
                                <!--<option (value)="role.order" (selected)="role.order">{{role.order}}</option>-->
                                <ng-container *ngFor="let a of number_of_roles_in_group; let order = index">
                                  <ng-container *ngIf="role.order == order + 1">
                                    <option
                                      (value)="(order)"
                                      selected="selected"
                                      (selected)="(role.order === order)"
                                    >
                                      {{ order + 1 }}
                                    </option>
                                  </ng-container>
                                  <ng-container *ngIf="role.order != order + 1">
                                    <option (value)="(order)" (selected)="(role.order === order)">
                                      {{ order + 1 }}
                                    </option>
                                  </ng-container>
                                </ng-container>
                              </select>
                            </div>
                          </td>
                          <td class="right-td">
                            <label class="slds-form-element__label" for="email_role_gr_{{ role.index }}">{{
                              role.name
                            }}</label>
                            <input
                              autocomplete="off"
                              type="text"
                              list="emails"
                              [(ngModel)]="role.email"
                              class="sn-sf-input"
                              id="email_role_gr_{{ role.index }}"
                              placeholder="###@##"
                              [readonly]="role.readonly"
                            />
                          </td>
                        </tr>
                      </table>

                      <button
                        *ngIf="!template_setting?.is_hide_advanced_settings"
                        (click)="document_role.isShowAdvanced = !document_role.isShowAdvanced"
                        class="btn btn-primary btn-advanced"
                      >
                        <span class="glyphicon glyphicon-chevron-down"></span>&nbsp;Advanced settings
                      </button>
                    </div>
                    <div
                      *ngIf="!template_setting?.is_hide_advanced_settings"
                      id="advanced_settings_gr_{{ role.index }}"
                      class="collapse"
                      [class.show]="document_role.isShowAdvanced"
                    >
                      <div class="panel panel-default">
                        <div class="panel-body">
                          <fieldset>
                            <div class="form-group">
                              <label class="slds-form-element__label" for="expiration_gr_{{ role.index }}"
                                >Expiration Days</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="expiration_gr_{{ role.index }}"
                                  name="expiration_gr_{{ role.index }}"
                                  type="number"
                                  [(ngModel)]="role.expiration"
                                  class="sn-sf-input input-md"
                                  value="30"
                                />
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="slds-form-element__label" for="reminder_gr_{{ role.index }}"
                                >Reminder</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="reminder_gr_{{ role.index }}"
                                  name="reminder_gr_{{ role.index }}"
                                  type="number"
                                  [(ngModel)]="role.reminder"
                                  class="sn-sf-input input-md"
                                  value="0"
                                  [disabled]="role.isReminderDisabled"
                                />
                              </div>
                            </div>

                            <div class="form-group">
                              <label class="slds-form-element__label" for="password_gr_{{ role.index }}"
                                >Password</label
                              >
                              <div>
                                <input
                                  autocomplete="off"
                                  id="password_gr_{{ role.index }}"
                                  name="password_gr_{{ role.index }}"
                                  type="password"
                                  [(ngModel)]="role.password"
                                  placeholder="***********"
                                  class="sn-sf-input input-md"
                                />
                              </div>
                            </div>

                            <div class="form-group">
                              <label class="slds-form-element__label">
                                <input
                                  type="checkbox"
                                  name="allow-forwarding"
                                  [(ngModel)]="role.allow_reassign"
                                  class="slds-checkbox"
                                />
                                <span>Allow Forwarding</span>
                              </label>
                            </div>

                            <div class="form-group">
                              <div>
                                <button
                                  id="submit_gr_{{ role.index }}"
                                  class="btn btn-success no-margin"
                                  name="submit_gr_{{ role.index }}"
                                  (click)="document_role.isShowAdvanced = !document_role.isShowAdvanced"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="slds-grow">
              <div class="slds-form slds-form_horizontal">
                <div class="slds-form-element">
                  <label class="slds-form-element__label" for="subject">Subject</label>
                  <div class="slds-form-element__control">
                    <input
                      autocomplete="off"
                      type="text"
                      [(ngModel)]="subject"
                      class="sn-sf-input"
                      placeholder="Invite Email Subject"
                    />
                  </div>
                </div>
                <div class="slds-form-element">
                  <label class="slds-form-element__label" for="body">Body</label>
                  <div class="slds-form-element__control">
                    <textarea
                      [(ngModel)]="body"
                      class="slds-textarea"
                      placeholder="Invite Email Body"
                      style="height: 300px"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="slds-modal__footer left">
          <!--<button class="btn btn-neutral">Cancel</button>-->
          <button class="btn btn-primary" (click)="send_document_group_invite()">Send Document Group</button>
        </footer>
      </div>
    </section>
  </div>
</div>
